
export type LocationParams = { [name : string] : string | undefined };

export class Location {
    constructor(
        public name: string,
        public params: LocationParams
    ) { }

    eq(loc : Location) {
        if (this.name !== loc.name) return false;
        const keys = Object.keys(this.params);
        if (keys.length !== Object.keys(loc.params).length) return false;
        for (var k of keys)
            if (this.params[k] !== loc.params[k]) return false;
        return true;
    }
}



// WEBPACK FOOTER //
// ./lib/componentLocation.ts